{
  "AllNotifications": "Toutes les notifications",
  "NoLinkNotification": "Aucun lien disponible pour cette notification",
  "ViewAllAnnouncementTab": "Annonces",
  "ViewallNotificationTab": "Notifications",
  "preferences": "Modifier les préférences"
}
